var map = {
	"./regulation-01-preliminary-definitions.json": 7415,
	"./regulation-02-licensing-procedures.json": 9206,
	"./regulation-03-license-terms-conditions.json": 9720,
	"./regulation-04-amateur-station-operations.json": 3344,
	"./regulation-05-general-provisions.json": 363,
	"./regulation-06-rights-liability-penalties.json": 2846,
	"./regulation-07-frequency-allocations-call-signs.json": 7662
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6146;
module.exports = webpackAsyncContext;